"use client";
import { jsx as s } from "react/jsx-runtime";
import { forwardRef as R, useCallback as W } from "react";
import { UnstyledLink as q } from "../UnstyledLink/UnstyledLink.js";
import { mergeClasses as z } from "../../utils/merge-classes.js";
function A(r, o) {
  const a = W(
    (t) => {
      r && (t.preventDefault(), t.stopPropagation());
    },
    [r]
  );
  return r ? a : o;
}
const K = R(
  ({
    ariaChecked: r,
    ariaControls: o,
    ariaDescribedBy: a,
    ariaExpanded: t,
    ariaLabel: b,
    children: e,
    className: d,
    formId: k,
    id: v,
    isDisabled: n,
    isDisabledFocusable: i,
    isPressed: C,
    isSubmit: x,
    onBlur: y,
    onClick: p,
    onFocus: g,
    onKeyDown: P,
    onKeyUp: U,
    onMouseEnter: h,
    onMouseLeave: j,
    onTouchStart: w,
    role: B,
    target: I,
    url: f,
    ...l
  }, u) => {
    const c = {
      "aria-label": b,
      id: v,
      role: B
    }, m = {
      className: z(
        "focus-visible:outline-none",
        "focus-visible:ring",
        "aria-disabled:cursor-default",
        d
      ),
      onBlur: y,
      onClick: p,
      onFocus: g
    }, L = A(n, p);
    return f ? n || i ? (
      // Render an `<a>` so toggling disabled/enabled state changes only the
      // `href` and attributes instead of replacing the whole element.
      /* @__PURE__ */ s(
        "a",
        {
          ...c,
          "aria-disabled": !0,
          className: d,
          ref: u,
          tabIndex: i ? 0 : void 0,
          children: e
        }
      )
    ) : /* @__PURE__ */ s(
      q,
      {
        ...c,
        ...m,
        ref: u,
        target: I,
        url: f,
        ...l,
        children: e
      }
    ) : /* @__PURE__ */ s(
      "button",
      {
        ...c,
        ...m,
        "aria-checked": r,
        "aria-controls": o,
        "aria-describedby": a,
        "aria-disabled": i ? !0 : void 0,
        "aria-expanded": t,
        "aria-pressed": C,
        disabled: n,
        form: k,
        onClick: L,
        onKeyDown: P,
        onMouseEnter: h,
        onMouseLeave: j,
        onTouchStart: w,
        onKeyUp: U,
        ref: u,
        type: x ? "submit" : "button",
        ...l,
        children: e
      }
    );
  }
);
export {
  K as UnstyledButton
};
